import { ApiResponse } from '@/utils';
import { enhancedRequest } from '@/utils/enhancedRequest';
import { AccountListResponse, TokenExchangeResponse } from '../types';

/**
 * 团队空间服务（V0.1 团队协作）
 * 契约：《20261023团队协作v0.1后端技术方案》
 * baseURL 已含 /v1，故路径不带 /v1 前缀。
 */
class TeamService {
  /** 账户列表：个人账户 + 团队账户（team_role：1-拥有者 2-成员；total_credits 单位分） */
  async getAccountList(): Promise<ApiResponse<AccountListResponse>> {
    return enhancedRequest.post<AccountListResponse>('/user/account_list', {}, {
      enableDeduplication: true,
      requestKey: 'team-account-list',
      retryCount: 1,
      timeout: 10000,
    });
  }

  /** 交换 token：空间切换核心。target_user_id = 目标账户（个人或团队）的 user_id；团队 token 前缀 t_ */
  async exchangeToken(targetUserId: string): Promise<ApiResponse<TokenExchangeResponse>> {
    return enhancedRequest.post<TokenExchangeResponse>(
      '/auth/token/exchange',
      { target_user_id: targetUserId },
      {
        enableDeduplication: false, // 切换必须真实发起，绝不走去重/缓存
        retryCount: 0,
        timeout: 10000,
      }
    );
  }
}

export const teamService = new TeamService();
export default teamService;
